import ThemeColors from "tailwind.config/colors";


export const COLORS = {
  /**
   * @deprecated should not need this, our common components should use these colors by default
   */
  PRIMARY_BLUE: ThemeColors.primary[600],   // for buttons and selected states
  /**
   * @deprecated should not need this, our common components should use these colors by default
   */
  PRIMARY_PURPLE: ThemeColors.primary[400], // for checkmarks
  /**
   * @deprecated tailwind does have a 'white' color
   */
  WHITE: '#FFFFFF',
} as const;
